module.exports = __webpack_public_path__ + "public/media/kazlak.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/kazlak.png
// module id = ./images/partners/kazlak.png
// module chunks = 0